<template>
    <div class="container">
        <div class="meet-level trans">
            <meet-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />

            <div class="main">
                <h2 class="tit">联系我们</h2>
                <div class="details shadow" ><div class="inputDeep"><el-input disabled type="textarea"  :rows="12" v-model ="this.link"></el-input></div></div>
            </div>
        </div>
    </div>
</template>

<script>
import meetHeader from "@/components/header";
import CurrentConferenceMixin from "@/mixin/CurrentConference"
export default {
    name: "linkDetail",
    components: {
        meetHeader,
    },
    mixins: [ CurrentConferenceMixin ],
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-xiangyou",
                headerTitle: "详细信息",
            },
            link:""
        };
    },
    async created(){
            await  this.$store.dispatch("conference/getCurrentConference")
            if(this.currentConference.affairs){
                this.link = this.currentConference.affairs[0].link
            }
            
           
        
    },
     watch: {
      currentConference: {
        handler(currentConference) {
            console.log(currentConference)
          this.link = currentConference.affairs[0].link
        },
        deep: true,
      },
    },
    methods: {
        handleClickIocn() {
            this.$router.go(-1)
            // history.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .inputDeep .el-textarea__inner {
    border: 0;
    resize: none;/* 这个是去掉 textarea 下面拉伸的那个标志 */
  }
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: white;
    color:black
  }
.main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
        padding-left: 8px;
        margin-top: 30px;
        border-left: 4px solid var(--main-color);
        font-size: 18px;
        font-weight: bold;
        color: var(--main-color);
    }

   
    .details {
        width: 100%;
        margin-top: 30px;
        font-size: 14px;
        padding: 15px;
        line-height: 28px;
        color: #666;
        border-radius: 5px;
        box-sizing: border-box;
    }
}
</style>